<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN" id="_idParaDest-5"><span class="CharOverride-7"> </span></p>
<p class="DED">For my sister, Lisa,</p>
<p class="DED">with love and gratitude</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021970854.vue?41fe9438